import type { SectionVisibleReturn } from 'src/redux/visibilityTracking';
import { FilterOptionValue } from 'src/types';

export const FILTER_LIST_ITEM_VISIBILITY_NAME = 'filterListItem';

export type FilterEventCategory = 'Filters' | 'Quick filters';

export interface CustomFilterEvent {
  event: 'custom_event';
  event_category: FilterEventCategory;
  event_action: string;
  event_label: FilterOptionValue;
}

export interface DeliveryQuickFilterImpression {
  event: 'custom_event';
  event_category: 'Quick filters';
  event_action: 'quick filter impression';
  event_label: 'delivery';
}

export interface DeliveryFilterImpression {
  event: 'custom_event';
  event_category: 'Filters';
  event_action: 'filter impression';
  event_label: 'delivery';
}

export interface AllFiltersViewedImpression {
  event: 'custom_event';
  event_category: 'Filters';
  event_action: 'filter impression';
  event_label: 'all filters viewed';
}

export interface FilterListItemImpressionActionPayload {
  filterUid: string;
}

export type FilterListItemImpressionActionReturn =
  SectionVisibleReturn<FilterListItemImpressionActionPayload>;
